import { useState } from "react";
import { useTranslation } from "react-i18next";

import { api, getApiErrorMessage, setAccessToken } from "../lib/api";

export function LoginPage() {
  const { t } = useTranslation(["auth", "errors"]);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      const resp = await api.post<{ access_token: string }>("/api/v1/auth/login", { email, password });
      setAccessToken(resp.data.access_token);
      window.location.href = "/dashboard";
    } catch (err) {
      setError(getApiErrorMessage(err, "auth:failed"));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 p-4">
      <div className="card w-full max-w-md">
        <div className="card-header">
          <h1 className="text-xl font-semibold">{t("auth:title")}</h1>
          <p className="mt-1 text-sm text-slate-500">{t("auth:subtitle")}</p>
        </div>
        <form className="card-body space-y-4" onSubmit={handleSubmit}>
          {error && (
            <div className="rounded-md bg-red-50 p-3 text-sm text-red-700">{error}</div>
          )}
          <div>
            <label className="mb-1 block text-sm font-medium">{t("auth:email")}</label>
            <input
              className="input"
              type="email"
              placeholder="you@company.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div>
            <label className="mb-1 block text-sm font-medium">{t("auth:password")}</label>
            <input
              className="input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button className="btn-primary w-full" type="submit" disabled={submitting}>
            {submitting ? t("auth:submitting") : t("auth:submit")}
          </button>
          <div className="flex items-center justify-between text-sm">
            <a className="text-brand-700 hover:underline" href="/register">
              {t("auth:createAccount")}
            </a>
            <a className="text-slate-500 hover:underline" href="#">
              {t("auth:forgotPassword")}
            </a>
          </div>
        </form>
      </div>
    </div>
  );
}
